import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "booking-view travel-overview"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "travel-info" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  for: "primaryEmail",
  class: "sr-only"
}
const _hoisted_8 = ["id"]
const _hoisted_9 = ["id", "value", "onChange"]
const _hoisted_10 = ["for"]
const _hoisted_11 = ["id"]
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "summary-list" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_17 = { class: "inline" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "price-box" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "conditions" }
const _hoisted_27 = { class: "standard" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "center-wrapper" }
const _hoisted_30 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_DotSpinner = _resolveComponent("DotSpinner")!
  const _component_EasyAlert = _resolveComponent("EasyAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.searchBookingOverview)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("header", null, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepHeadline']), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  class: "back-btn",
                  title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
                  to: { name: 'personal-data', query: _ctx.query }
                }, null, 8, ["title", "to"]),
                (_ctx.pageTexts['hotelPageBookingConfirmationStepInfoPopup'])
                  ? (_openBlock(), _createBlock(_component_EasyDrop, {
                      key: 0,
                      dropdownType: 'tooltip',
                      position: 'right'
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "rte",
                          innerHTML: _ctx.pageTexts['hotelPageBookingConfirmationStepInfoPopup']
                        }, null, 8, _hoisted_2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "rte",
                innerHTML: _ctx.pageTexts['hotelPageBookingConfirmationStepDescription']
              }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepLabelYourTravelDocuments']), 1),
              _createElementVNode("div", {
                class: "rte",
                innerHTML: _ctx.pageTexts['hotelPageBookingConfirmationStepLabelYourTravelDocumentsDescription']
              }, null, 8, _hoisted_5),
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    id: "primaryEmail",
                    type: "email",
                    value: 
              _ctx.bookingOverview.bookingSelection.hotelRooms[0].searchRoom
                .adults[0].email
            ,
                    readonly: "",
                    placeholder: " "
                  }, null, 8, _hoisted_6),
                  _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepLabelEmail']), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedEmails, (email, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    id: 'addedEmailWrapper_' + index,
                    class: "standard-input"
                  }, [
                    _createElementVNode("input", {
                      id: 'addedEmail_' + index,
                      type: "email",
                      value: email,
                      placeholder: " ",
                      onChange: ($event: any) => (_ctx.updateEmail($event, index))
                    }, null, 40, _hoisted_9),
                    _createElementVNode("label", {
                      for: 'addedEmail_' + index
                    }, _toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepLabelEmail']), 9, _hoisted_10),
                    _createElementVNode("div", {
                      id: 'addedEmailError_' + index,
                      class: "field-error",
                      hidden: ""
                    }, _toDisplayString(_ctx.pageTexts['hotelPageGeneralFormValidationInvalidEmail']), 9, _hoisted_11),
                    _createElementVNode("button", {
                      type: "button",
                      class: "delete-btn",
                      title: _ctx.pageTexts['hotelPageBookingConfirmationStepButtonRemoveEmailText'],
                      onClick: ($event: any) => (_ctx.deleteAddedEmail(index))
                    }, null, 8, _hoisted_12)
                  ], 8, _hoisted_8))
                }), 128)),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addEmail && _ctx.addEmail(...args)))
                }, _toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepLabelAddAnotherEmail']), 1)
              ]),
              _createElementVNode("picture", null, [
                _createElementVNode("img", {
                  src: _ctx.searchBookingOverview.travel.image,
                  alt: "Maldiverne",
                  width: "650",
                  height: "300"
                }, null, 8, _hoisted_13)
              ]),
              _createElementVNode("dl", _hoisted_14, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepLabelWhere']), 1),
                _createElementVNode("dd", null, _toDisplayString(_ctx.pageTexts['destination']), 1),
                _hoisted_15,
                _createElementVNode("dt", null, _toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepLabelDeparture']) + " " + _toDisplayString(_ctx.searchBookingOverview.flight.toDestinationSummary.startDepartureAirportName) + " (" + _toDisplayString(_ctx.searchBookingOverview.flight.toDestinationSummary
                .startDepartureAirportCode) + ") ", 1),
                _createElementVNode("dd", null, _toDisplayString(_ctx.formatDateTime(
                _ctx.bookingOverview.flight.toDestinationSummary.startDepartureDate
                        )), 1),
                _createElementVNode("dt", null, _toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepLabelArrival']) + " " + _toDisplayString(_ctx.searchBookingOverview.flight.fromDestinationSummary.endArrivalAirportName) + " (" + _toDisplayString(_ctx.searchBookingOverview.flight.fromDestinationSummary
                .endArrivalAirportCode) + ") ", 1),
                _createElementVNode("dd", null, _toDisplayString(_ctx.formatDateTime(
                _ctx.bookingOverview.flight.fromDestinationSummary.endArrivalDate
                        )), 1),
                _hoisted_16,
                _createElementVNode("dt", null, _toDisplayString(_ctx.hotelLabel), 1),
                _createElementVNode("dd", null, _toDisplayString(_ctx.bookingOverview.travel.hotelName), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRooms, (room, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "inline"
                  }, [
                    _createElementVNode("dt", null, [
                      _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageGeneralRoom']), 1),
                      (_ctx.selectedRooms.length > 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" " + _toDisplayString(index + 1), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("dd", null, _toDisplayString(room.name), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("dt", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelCatering']), 1),
                      _createElementVNode("dd", null, _toDisplayString(_ctx.selectedPensionName(room)), 1)
                    ])
                  ]))
                }), 128)),
                (_ctx.selectedTransfer)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_18,
                      _createElementVNode("dt", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelTransfer']), 1),
                      _createElementVNode("dd", null, _toDisplayString(_ctx.selectedTransfer.name), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_19,
                _createElementVNode("dt", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelPersonalInformation']), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formPersons, (person, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "inline",
                    key: index
                  }, [
                    (person.isAdult)
                      ? (_openBlock(), _createElementBlock("dt", _hoisted_20, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAdult']) + " " + _toDisplayString(person.personTypeIndex + 1), 1))
                      : (_openBlock(), _createElementBlock("dt", _hoisted_21, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelChild']) + " " + _toDisplayString(person.personTypeIndex + 1), 1)),
                    _createElementVNode("dd", null, _toDisplayString(person.searchPerson.firstName) + " " + _toDisplayString(person.searchPerson.middleName) + " " + _toDisplayString(person.searchPerson.lastName), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("strong", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepLabelTotalPrice']), 1),
                  (_ctx.bookingOverview.price.price)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.bookingOverview.price.price.toLocaleString(_ctx.localeStrings.longName)) + " " + _toDisplayString(_ctx.bookingOverview.price.currency), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepLabelTotalPriceSubtext']), 1)
              ]),
              _createElementVNode("div", {
                class: "extra-info rte",
                innerHTML: _ctx.pageTexts['hotelPageBookingConfirmationStepTextTaxInfoAlert']
              }, null, 8, _hoisted_24)
            ]),
            _createElementVNode("section", {
              class: "insurance rte",
              innerHTML: _ctx.pageTexts['hotelPageBookingConfirmationStepTextEnsurance']
            }, null, 8, _hoisted_25),
            _createElementVNode("fieldset", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  name: "conditions",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.hasAcceptedConditions) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.hasAcceptedConditions]
                ]),
                _createElementVNode("span", {
                  innerHTML: _ctx.pageTexts['hotelPageBookingConfirmationStepTextAcceptConditions']
                }, null, 8, _hoisted_28)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  id: "paymentButton",
                  class: "btn-primary",
                  disabled: !_ctx.hasAcceptedConditions || !_ctx.hasAllValidEmails || _ctx.paymentProcessing,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.bookTravel && _ctx.bookTravel(...args)))
                }, [
                  (_ctx.paymentProcessing)
                    ? (_openBlock(), _createBlock(_component_DotSpinner, { key: 0 }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageBookingConfirmationStepButtonGoToPayment']), 1)
                      ], 64))
                ], 8, _hoisted_30)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_EasyAlert, {
      alertHeader: _ctx.pageTexts['hotelPageGeneralErrorHeadline'],
      alertText: _ctx.alertMessage,
      closeBtnText: _ctx.pageTexts['hotelPageGeneralModalButtonClose'],
      isShowAlert: _ctx.isShowAlert,
      onCloseAlert: _ctx.closeAlert
    }, null, 8, ["alertHeader", "alertText", "closeBtnText", "isShowAlert", "onCloseAlert"])
  ], 64))
}